import React, {Fragment, useEffect} from 'react';
import {List} from '../../../../components';
import {connect} from 'react-redux';


function CollectionsSection(props){

  useEffect(()=>{

  },[])

  return(
    <div style={{marginTop:'100px'}}>
      COLLECTIONS
    </div>
  );
}

export default connect(ss,dd)(CollectionsSection);


function ss(state){

}

function dd(dispatch){

}
